<template>
  <div class="main">
    <Head></Head>
    <div class="body">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Head from '@components/header.vue'
export default {
  components: { Head }
}
</script>

<style scoped lang="scss">
.main {
  background: #dddddd;
  .body {
    overflow-y: auto;
    height: calc(100vh - 60px);
  }
}
</style>
